<ng-container [formGroup]="form">
  <mat-form-field2 class="dial-code-select">
    <app-select
      [items]="filteredDialCodes"
      formControlName="code"
      bindLabel="codeDisplay"
      bindValue="code"
      i18n-placeholder
      placeholder="Code"
      [required]="required"
      [searchable]="true"
      (searchChange)="(onSearch)"
    >
      <ng-template selectItem let-item="item">
        <div class="d-flex align-items-center">
          <span class="flag-icon mr-1" [ngClass]="'flag-icon-' + item.cc" style="min-width: 18px"></span>
          <span class="flex-fill text-truncate">
            {{ item.codeDisplay }}
          </span>
        </div>
      </ng-template>
    </app-select>
    <mat-error *ngIf="codeCtrl.touched && codeCtrl.hasError('required')" i18n>Code is required.</mat-error>
    <mat-error *ngIf="codeCtrl.hasError('code')" i18n>Code is required.</mat-error>
  </mat-form-field2>
  <mat-form-field2 class="phone-number">
    <input type="text" formControlName="phone" matInput [placeholder]="phoneLabel" [required]="required" />
    <mat-error *ngIf="phoneCtrl.hasError('phone')">
      {{ phoneLabel }}<ng-container>&nbsp;</ng-container><ng-container i18n>is invalid.</ng-container>
    </mat-error>
    <mat-error *ngIf="phoneCtrl.touched && phoneCtrl.hasError('required')">
      {{ phoneLabel }}<ng-container>&nbsp;</ng-container><ng-container i18n>is required.</ng-container>
    </mat-error>
  </mat-form-field2>
</ng-container>
